import * as React from 'react';

function PaginaInicio(){
    return (
      <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <p>
          {/* Edit <code>src/App.js</code> and save to reload. */}
          Pagina Inicial
        </p>
        <p>
          {/* Edit <code>src/App.js</code> and save to reload. */}
          Luis Guzmán
        </p>
        {/* <p>
          {elemento}
        </p> */}
        {/* <p>{count}</p> 
        <button onClick={sum}> add</button> */}
        {/* <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Luis Guzmán
        </a> */}
      </header>
    </div>
    )
  }

export default PaginaInicio